const VISITOR_KEY = "gt_visitor_id";
const LAST_SENT_KEY = "gt_home_track_last";
const MIN_INTERVAL_MS = 3000; // blocks React StrictMode double-invocation in dev

function ensureVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return "v_anon_" + Math.random().toString(36).slice(2);
  }
}

export function trackHomeVisit() {
  try {
    const now = Date.now();
    const last = Number(sessionStorage.getItem(LAST_SENT_KEY) || 0);
    if (now - last < MIN_INTERVAL_MS) return;
    sessionStorage.setItem(LAST_SENT_KEY, String(now));

    const visitor_id = ensureVisitorId();
    const body = JSON.stringify({
      visitor_id,
      referrer: document.referrer || null,
      path: "/",
    });

    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track/home`;
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {
      /* silent */
    });
  } catch {
    /* silent */
  }
}
